import {defaultState} from '../state';

import * as WizardActions from '../../actions/WizardActions';
import * as WizardMXActions from '../../actions/WizardMXActions';
import * as LoanApplicationActions from '../../actions/LoanApplicationActions';
import * as ProfileActions from '../../actions/ProfileActions';
import * as FileTypeConstants from '../../../common/constants/FileTypeConstants';
import {SUMMARY_MX} from '../../constants/LabelConstants';
import * as UIActions from '../../actions/UIActions';
import * as WizardValidationUtils from '../../utils/WizardValidationUtils';
import {
    ApplicantInfoSummaryDTO,
    ContinueHeaderSummaryDTO,
    DocumentsSummaryDTO,
    EmploymentInfoSummaryDTO,
    FieldApplicantSummary, ReferencesSummaryDTO
} from '../../types/mx/creditoReal/epics';
import {Catalog} from '../../../common/types/common';
import * as LoginActions from '../../actions/LoginActions';
import {
    PersonalDataTurboCashStepViewFieldErrorState,
    WorkDataTurboCashStepViewErrorFieldState
} from '../../types/mx/turboCash/reducers';
import {getCatalogHouseHoldMeasure, getCatalogHouseHoldTime} from '../../utils/WizardResponseMapperUtils';
import * as GlobalConstants from '../../constants/GlobalConstants';

const loanApplication = (state = defaultState.turboCash.loanApplication, action) => {

    switch (action.type) {

        case ProfileActions.GOT_PROFILE_INFO_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    email: action.email,
                }
            };
        case WizardActions.CHANGE_FIRST_NAME_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    firstName: action.firstName,
                }
            };
        case WizardActions.CHANGE_SECOND_NAME_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    secondName: action.secondName,
                }
            };
        case WizardActions.CHANGE_LAST_NAME_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    lastName: action.lastName,
                }
            };
        case WizardActions.CHANGE_SECOND_LAST_NAME_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    secondLastName: action.secondLastName,
                }
            };
        case WizardActions.CHANGE_BIRTH_DATE_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    birthDate: action.birthDate,
                }
            };
        case WizardActions.CHANGE_DOC_NUMBER_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    docNumber: action.docNumber
                }
            };
        case WizardActions.CHANGE_CELL_PHONE_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    cellPhone: action.cellPhone
                }
            };
        case WizardActions.CHANGE_EMAIL_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    email: action.email
                }
            };
        case WizardActions.CHANGE_CIVIL_STATUS_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    civilStatus: action.civilStatus
                }
            };

        case WizardActions.CHANGE_REGIME_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    regime: action.regime
                }
            };

        case WizardActions.CHANGE_ROL_HOME_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    rolHome: action.rolHome
                }
            };

        case WizardActions.CHANGE_STUDIES_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    studies: action.studies
                }
            };

        case WizardActions.CHANGE_HOUSE_TYPE_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    houseType: action.houseType
                }
            };

        case WizardActions.CHANGE_AMOUNT_DEPENDENTS_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    amountDependents: action.amountDependents
                }
            };

        case WizardActions.CHANGE_CURP_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    cURP: action.cURP
                }
            };

        case WizardActions.CHANGE_HOUSEHOLD_TIME_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    houseHoldTime: action.houseHoldTime
                }
            };
        case WizardActions.CHANGE_HOUSEHOLD_MEASURE_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    houseHoldMeasure: action.houseHoldMeasure
                }
            };
        case LoanApplicationActions.SET_HIGHEST_STEP_ACTION.name: {
            return {
                ...state,
                highestStep: action.step
            };
        }
        case WizardActions.SET_LOAN_APPLICATION_TOKEN_TC_ACTION.name:
            return {
                ...state,
                token: action.token
            };

        case WizardActions.CHANGE_HOME_ADDRESS_ACTION.name:
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    address: action.address
                }
            };

        case WizardActions.CHANGE_HOME_EXT_NUMBER_ACTION.name:
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    extNumber: action.extNumber
                }
            };

        case WizardActions.CHANGE_HOME_INT_NUMBER_ACTION.name:
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    intNumber: action.intNumber
                }
            };

        case WizardActions.CHANGE_HOME_POSTAL_CODE_ACTION.name:
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    postalCode: action.postalCode
                }
            };
        case WizardActions.CHANGE_HOME_PHONE_ACTION.name:
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    phone: action.phone
                }
            };

        case WizardActions.CHANGE_HOME_COLONY_MX_ACTION.name:
            const defaultCatalog = WizardValidationUtils.defaultCatalog;
            const colony = action.colony ? action.colony : defaultCatalog;
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    selectedColony: colony
                }
            };
        case WizardActions.CHANGE_HOME_STATES_ACTION.name: {
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    state: action.state,
                }
            };
        }
        case WizardActions.CHANGE_HOME_CITY_ACTION.name: {
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    city: action.city,
                }
            };
        }
        case WizardActions.CHANGE_HOME_MUNICIPALITY_ACTION.name: {
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    municipality: action.municipality,
                }
            };
        }
        case WizardActions.CHANGE_HOME_COLONIES_ACTION.name: {
            const defaultCatalog = {id: '', value: ''};
            let colony = action.colonies.find(i => i.id === state.applicantHome.selectedColony.id) || defaultCatalog;
            if (action.colonies.length === 1) {
                colony = {id: action.colonies[0].id, value: action.colonies[0].value};
            }
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    selectedColony: colony,
                    colonies: action.colonies
                }
            };
        }
        case LoanApplicationActions.ERROR_GOT_LOCATIONS_ACTION.name: {
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    state: {
                        id: '',
                        value: '',
                    },
                    city: {
                        id: '',
                        value: '',
                    },
                    municipality: {
                        id: '',
                        value: '',
                    },
                    selectedColony: {
                        id: '',
                        value: '',
                    }
                }
            };
        }

        case WizardActions.CHANGE_EMPLOYMENT_WORKPLACE_NAME_TC_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    workplaceName: action.workplaceName,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_POSITION_TC_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    position: action.position,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_WORKING_SINCE_TC_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    workingSince: action.workingSince,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_ROTATION_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    employmentRotation: action.employmentRotation,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_ADDRESS_TC_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    address: action.address,
                },
            };
        case WizardActions.CHANGE_EMPLOYMENT_EXT_NUMBER_TC_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    extNumber: action.extNumber,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_INT_NUMBER_TC_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    intNumber: action.intNumber,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_STREET_BETWEEN_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    streetBetween: action.streetBetween,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_WORKPLACE_PHONE_TC_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    workplacePhone: action.workplacePhone,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_WORKPLACE_PHONE_EXT_TC_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    workplacePhoneExt: action.workplacePhoneExt,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_MONTHLY_INCOMES_TC_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    monthlyIncomes: action.monthlyIncomes,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_POSTAL_CODE_TC_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    postalCode: action.postalCode,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_STATES_TC_ACTION.name: {
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    state: action.state,
                }
            };
        }

        case WizardActions.CHANGE_EMPLOYMENT_STATES_REFERENCES_TC_ACTION.name: {
            return {
                ...state,
                otherReferences: {
                    ...state.otherReferences,
                    tempDataReference: {
                        ...state.otherReferences.tempDataReference,
                        index: action.index,
                        data: {
                            ...state.otherReferences.tempDataReference.data,
                            state: action.state
                        }
                    }
                }
            };
        }

        case WizardActions.CHANGE_EMPLOYMENT_CITY_TC_ACTION.name: {
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    city: action.city,
                }
            };
        }

        case WizardActions.CHANGE_EMPLOYMENT_CITY_REFERENCES_TC_ACTION.name: {
            return {
                ...state,
                otherReferences: {
                    ...state.otherReferences,
                    tempDataReference: {
                        ...state.otherReferences.tempDataReference,
                        index: action.index,
                        data: {
                            ...state.otherReferences.tempDataReference.data,
                            city: action.city
                        }
                    }
                }
            };
        }

        case WizardActions.CHANGE_EMPLOYMENT_MUNICIPALITY_TC_ACTION.name: {
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    municipality: action.municipality,
                }
            };
        }

        case WizardActions.CHANGE_EMPLOYMENT_MUNICIPALITY_REFERENCES_TC_ACTION.name: {
            return {
                ...state,
                otherReferences: {
                    ...state.otherReferences,
                    tempDataReference: {
                        ...state.otherReferences.tempDataReference,
                        index: action.index,
                        data: {
                            ...state.otherReferences.tempDataReference.data,
                            municipality: action.municipality
                        }
                    }
                }
            };
        }

        case WizardActions.CHANGE_EMPLOYMENT_COLONY_MX_TC_ACTION.name:
            const employmentColony = action.colony ? action.colony : WizardValidationUtils.defaultCatalog;
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    selectedColony: employmentColony
                }
            };

        case WizardActions.CHANGE_EMPLOYMENT_COLONIES_TC_ACTION.name: {
            const defaultCatalog = {id: '', value: ''};
            const selectedColony: Catalog = state.applicantEmployment.selectedColony;
            const stateColonyId: string = !!selectedColony ? selectedColony.id : '';
            let colony = action.colonies
                .find(i => i.id === stateColonyId) || defaultCatalog;
            if (action.colonies.length === 1) {
                colony = {id: action.colonies[0].id, value: action.colonies[0].value};
            }
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    selectedColony: colony,
                    colonies: action.colonies
                }
            };
        }

        case WizardActions.CHANGE_EMPLOYMENT_COLONIES_REFERENCES_TC_ACTION.name: {
            const defaultCatalog = {id: '', value: ''};
            const selectedColony: Catalog = state.applicantEmployment.selectedColony;
            const stateColonyId: string = !!selectedColony ? selectedColony.id : '';
            let colony = action.colonies
                .find(i => i.id === stateColonyId) || defaultCatalog;
            if (action.colonies.length === 1) {
                colony = {id: action.colonies[0].id, value: action.colonies[0].value};
            }
            return {
                ...state,
                otherReferences: {
                    ...state.otherReferences,
                    tempDataReference: {
                        ...state.otherReferences.tempDataReference,
                        index: action.index,
                        data: {
                            ...state.otherReferences.tempDataReference.data,
                            selectedColony: colony,
                            colonies: action.colonies
                        }
                    }
                }
            };
        }

        case WizardActions.CHANGE_OTHER_REFERENCES_TC_ACTION.name:
            return {
                ...state,
                otherReferences: {
                    ...state.otherReferences,
                    references: action.otherReferences
                },
            };

        case WizardMXActions.GOT_LOAN_APPLICATION_BY_TOKEN.name:
            const references = action.loanApplication.references;
            const highestStep = action.loanApplication.step;
            const token = action.loanApplication.token;
            return {
                ...state,
                highestStep,
                token,
                otherReferences: {
                    ...state.otherReferences,
                    references
                }
            };

        case WizardActions.UPLOADED_FILES_TC_ACTION.name:
            const defaultDocs = {lastVersion: { documents: []}};
            const filesList = action.files[0];
            const files = filesList && filesList.documentGroups && filesList.documentGroups;

            const identificationFiles = files && files.find(item =>
                item.documentType.id === FileTypeConstants.IDENTIFICATION_TYPE) || defaultDocs;
            const ifeFrontFiles = identificationFiles.lastVersion.documents.filter(item =>
                item.fileDetail === FileTypeConstants.IFE_FRONT_SECTION);
            const ifeBackFiles = identificationFiles.lastVersion.documents.filter(item =>
                item.fileDetail === FileTypeConstants.IFE_BACK_SECTION);

            const homeFiles = files && files.find(item =>
                item.documentType.id === FileTypeConstants.HOME_TYPE) || defaultDocs;
            const homeFilesWithSection = homeFiles.lastVersion.documents.filter(item =>
                item.fileDetail === FileTypeConstants.HOME_SECTION);

            const otherFiles = files && files.find(item =>
                item.documentType.id === FileTypeConstants.OTHER_TYPE) || defaultDocs;
            const otherMonth1Files = otherFiles.lastVersion.documents.filter(item =>
                item.fileDetail === FileTypeConstants.INCOMES_FIRST_SECTION);
            const otherMonth2Files = otherFiles.lastVersion.documents.filter(item =>
                item.fileDetail === FileTypeConstants.INCOMES_SECOND_SECTION);
            const otherMonth3Files = otherFiles.lastVersion.documents.filter(item =>
                item.fileDetail === FileTypeConstants.INCOMES_THIRD_SECTION);

            const carLicenceFiles = files && files.find(item =>
                item.documentType.id === FileTypeConstants.DRIVER_LICENSE_TYPE) || defaultDocs;
            const carLicenceFrontFiles = carLicenceFiles.lastVersion.documents.filter(item =>
                item.fileDetail === FileTypeConstants.DRIVER_LICENSE_FRONT_SECTION);
            const carLicenceBackFiles = carLicenceFiles.lastVersion.documents.filter(item =>
                item.fileDetail === FileTypeConstants.DRIVER_LICENSE_BACK_SECTION);
            return {
                ...state,
                files: {
                    identification: {
                        ifeFrontFiles,
                        ifeBackFiles
                    },
                    home: {
                        homeFiles: homeFilesWithSection
                    },
                    other: {
                        otherMonth1Files,
                        otherMonth2Files,
                        otherMonth3Files
                    },
                    carLicence: {
                        carLicenceFrontFiles,
                        carLicenceBackFiles
                    }
                }
            };

        case WizardMXActions.SET_CONTINUE_HEADER_DATA_STATE_ACTION.name:
            const continueHeaderFieldSummary: ContinueHeaderSummaryDTO = action.continueHeader;

            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    firstName: continueHeaderFieldSummary.firstName,
                    secondName: continueHeaderFieldSummary.secondName,
                    lastName: continueHeaderFieldSummary.lastName,
                    secondLastName: continueHeaderFieldSummary.secondLastName
                }
            };

        case WizardMXActions.SET_APPLICANT_INFO_DATA_STATE_ACTION.name:
            const applicantInfoFieldSummary:
                FieldApplicantSummary<ApplicantInfoSummaryDTO, PersonalDataTurboCashStepViewFieldErrorState>
                = action.applicantInfo;
            const applicantInfoSummary: ApplicantInfoSummaryDTO = applicantInfoFieldSummary.data;
            const houseHoldMeasureCatalog =
                getCatalogHouseHoldMeasure(applicantInfoSummary.holdTimeMeasure, action.state) ||
                GlobalConstants.EMPTY_DISPLAY_VALUE;
            const houseHoldTimeCatalog = getCatalogHouseHoldTime(applicantInfoSummary.holdTime);

            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    civilStatus: applicantInfoSummary.civilStatus || GlobalConstants.EMPTY_CATALOG,
                    regime: applicantInfoSummary.regimen || GlobalConstants.EMPTY_CATALOG,
                    rolHome: applicantInfoSummary.roleAtHome || GlobalConstants.EMPTY_CATALOG,
                    studies: applicantInfoSummary.studiesLevel || GlobalConstants.EMPTY_CATALOG,
                    amountDependents: applicantInfoSummary.economicDependents,
                    cURP: applicantInfoSummary.curp,
                    houseType: applicantInfoSummary.houseType || GlobalConstants.EMPTY_CATALOG,
                    houseHoldTime: houseHoldTimeCatalog,
                    houseHoldMeasure: houseHoldMeasureCatalog
                }
            };

        case WizardMXActions.SET_EMPLOYMENT_INFO_DATA_STATE_ACTION.name:
            const employmentInfoFieldSummary:
                FieldApplicantSummary<EmploymentInfoSummaryDTO, WorkDataTurboCashStepViewErrorFieldState>
                = action.employmentInfo;
            const employmentInfoSummary: EmploymentInfoSummaryDTO = employmentInfoFieldSummary.data;
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    workplaceName: employmentInfoSummary.workplaceName,
                    position: employmentInfoSummary.position,
                    workingSince: employmentInfoSummary.workingSince.displayValue,
                    employmentRotation: employmentInfoSummary.employmentBussinessType || GlobalConstants.EMPTY_CATALOG,
                    address: employmentInfoSummary.address,
                    extNumber: employmentInfoSummary.extNumber,
                    intNumber: employmentInfoSummary.intNumber,
                    streetBetween: employmentInfoSummary.streets,
                    monthlyIncomes: employmentInfoSummary.monthlyIncomes.value,
                    postalCode: employmentInfoSummary.postalCode,
                    state: employmentInfoSummary.state || GlobalConstants.EMPTY_CATALOG,
                    city: employmentInfoSummary.city || GlobalConstants.EMPTY_CATALOG,
                    municipality: employmentInfoSummary.municipality || GlobalConstants.EMPTY_CATALOG,
                    selectedColony: employmentInfoSummary.colony || GlobalConstants.EMPTY_CATALOG,
                    workplacePhone: employmentInfoSummary.workplacePhone,
                    workplacePhoneExt: employmentInfoSummary.workplacePhoneExt
                }
            };

        case WizardMXActions.SET_REFERENCES_DATA_STATE_ACTION.name:
            const referencesFieldSummary:
                FieldApplicantSummary<[ReferencesSummaryDTO], {}>
                = action.references;
            const referencesSummary: [ReferencesSummaryDTO] = referencesFieldSummary.data;
            const referencesMapper = referencesSummary.map(reference => ({
                completeName: reference.completeName,
                cellphone: reference.phone,
                phone: reference.landLinePhone,
                address: reference.address,
                extNumber: reference.extNumber,
                intNumber: reference.intNumber,
                postalCode: reference.postalCode,
                state: reference.state,
                city: reference.city,
                municipality: reference.municipality,
                colonies: reference.colonies,
                selectedColony: reference.colony
            }));
            return {
                ...state,
                otherReferences: {
                    ...state.otherReferences,
                    references: referencesMapper
                }
            };

        case WizardMXActions.SET_DOCUMENTS_DATA_STATE_ACTION.name:
            const documentsFieldSummary:
                FieldApplicantSummary<[DocumentsSummaryDTO], {}>
                = action.documents;
            const documentsSummary: [DocumentsSummaryDTO] = documentsFieldSummary.data;
            const defaultDocsSummary = {lastVersion: { documents: []}};
            const documentGroupsSummary = documentsSummary.length && documentsSummary.pop().documentGroups;

            const identificationSummaryFiles = documentGroupsSummary && documentGroupsSummary.find(item =>
                item.documentType.id === FileTypeConstants.IDENTIFICATION_TYPE) || defaultDocsSummary;
            const ifeFrontSummaryFiles = identificationSummaryFiles.lastVersion.documents.filter(item =>
                item.fileDetail === FileTypeConstants.IFE_FRONT_SECTION);
            const ifeBackSummaryFiles = identificationSummaryFiles.lastVersion.documents.filter(item =>
                item.fileDetail === FileTypeConstants.IFE_BACK_SECTION);

            const homeSummaryFiles = documentGroupsSummary && documentGroupsSummary.find(item =>
                item.documentType.id === FileTypeConstants.HOME_TYPE) || defaultDocsSummary;
            const homeFilesWithSummarySection = homeSummaryFiles.lastVersion.documents.filter(item =>
                item.fileDetail === FileTypeConstants.HOME_SECTION);

            const otherSummaryFiles = documentGroupsSummary && documentGroupsSummary.find(item =>
                item.documentType.id === FileTypeConstants.OTHER_TYPE) || defaultDocsSummary;
            const otherMonth1SummaryFiles = otherSummaryFiles.lastVersion.documents.filter(item =>
                item.fileDetail === FileTypeConstants.INCOMES_FIRST_SECTION);
            const otherMonth2SummaryFiles = otherSummaryFiles.lastVersion.documents.filter(item =>
                item.fileDetail === FileTypeConstants.INCOMES_SECOND_SECTION);
            const otherMonth3SummaryFiles = otherSummaryFiles.lastVersion.documents.filter(item =>
                item.fileDetail === FileTypeConstants.INCOMES_THIRD_SECTION);

            const carLicenceSummaryFiles = documentGroupsSummary && documentGroupsSummary.find(item =>
                item.documentType.id === FileTypeConstants.DRIVER_LICENSE_TYPE) || defaultDocsSummary;
            const carLicenceFrontSummaryFiles = carLicenceSummaryFiles.lastVersion.documents.filter(item =>
                item.fileDetail === FileTypeConstants.DRIVER_LICENSE_FRONT_SECTION);
            const carLicenceBackSummaryFiles = carLicenceSummaryFiles.lastVersion.documents.filter(item =>
                item.fileDetail === FileTypeConstants.DRIVER_LICENSE_BACK_SECTION);
            return {
                ...state,
                files: {
                    identification: {
                        ifeFrontFiles: ifeFrontSummaryFiles,
                        ifeBackFiles: ifeBackSummaryFiles
                    },
                    home: {
                        homeFiles: homeFilesWithSummarySection
                    },
                    other: {
                        otherMonth1Files: otherMonth1SummaryFiles,
                        otherMonth2Files: otherMonth2SummaryFiles,
                        otherMonth3Files: otherMonth3SummaryFiles
                    },
                    carLicence: {
                        carLicenceFrontFiles: carLicenceFrontSummaryFiles,
                        carLicenceBackFiles: carLicenceBackSummaryFiles
                    }
                }
            };

        case WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN_TURBO_CASH.name:
            return {
                ...defaultState.turboCash.loanApplication,
                applicantPersonal: {
                    ...defaultState.turboCash.loanApplication.applicantPersonal,
                    email: state.applicantPersonal.email,
                    firstName: state.applicantPersonal.firstName,
                    lastName: state.applicantPersonal.lastName
                }
            };
        case UIActions.CLEAN_STATE_ACTION.name:
        case LoginActions.LOGOUT_SUCCESS_ACTION.name:
            return defaultState.turboCash.loanApplication;
        default:
            return state;
    }

};

export default loanApplication;